/**
 *  Copyright 2018 Avaya Inc. All Rights Reserved.
 *
 * Usage of this source is bound to the terms described in
 * licences/License.txt
 *
 * Avaya - Confidential & Proprietary. Use pursuant to your signed agreement or
 * Avaya Policy
 *
 * Handles the UI side of the web chat library, which is based around jQuery UI. Replace the following with your own UI code, if you prefer.
 */
import $ from 'jquery'
import chatSocket from "./webChatSocket"
import webSocket from "./webChatConfig"
import webChat from "./webChat"
import chatConfig from "./webChatConfig"
import chatLogon from "./webChatLogon"
import jQuery from 'jquery'
import Vue from 'vue'

export default {

    playwithHeight: true,

    /**
     * Change the textContent of the specified element.
     * @param el
     * @param newText
     */
    changeElementText : function(el, newText) {
        'use strict';
        $(el).text(newText);
    },

    /**
     * Add the EWT to the chat tab. Included as an alternative to using an alert window.
     */
    addEwtToChatTab : function(waitTime) {
        'use strict';
        $('#liveChatLink').attr('title',
            'Click to chat with an agent! Wait time is approximately ' + waitTime + ' minutes');
    },

    /**
     * Changes the chat panel to chat mode.
     */
    changeToChatMode : function() {
        'use strict';
        $('#mainChatLogin').hide();//$('#chatForm').hide();
        $('#mobChat').show();//$('#chatInterface').show();
    },

    /**
     * Changes the chat panel to login mode.
     */
    changeToLoginMode : function() {
        'use strict';
        $('#mobChat').hide();
        $('#mainChatLogin').show();
    },

    resetChatUI : function() {
        'use strict';
        //$("#chatFeedback").show();
        //this.changeToLoginMode();
        $("#comments").val("");
        $("#history").empty();
    },

    /**
     * Create and show an alert
     * @param {string} msg
     */
    showAlert : function(msg) {
        'use strict';
        $('#alertDialog').dialog({
            draggable : false,
            resizeable : false,
            buttons : {
                OK : function() {
                    $(this).dialog('close');
                }
            }
        }).text(msg);
    },

    closePanel : function(event) {
        'use strict';
        event.preventDefault();
        console.debug("WebChat: closing chat panel");

        // when the chat dialog is closed, reset things
        chatSocket.clearRefresh();
        chatSocket.manualClose = true;
        clearTimeout(chatSocket.closeTimer);
        if (webSocket.readyState !== WebSocket.CLOSING) {
            chatConfig.dontRetryConnection = true;
            webChat.quitChat();
        }
    },

    /**
     * Sets up the UI code.
     */
    /* TODO: Look at this again */
    setup : function() {
        'use strict';
        console.log("webchatui setup")
        $("#comments").on("keydown", webChat.onType);
    },

    /**
     * Reload the chat panel after a refresh
     */
    reloadChatPanel: function() {
        'use strict';
        console.log("Reloading chat panel");
        this.changeToChatMode();
    },

    getChatMessage: function(){
        "use strict";
        return $("#comments").val();
    },

    /**
     * Disable the chatbox and sendbutton.
     * @param {Boolean} isDisabled - if true, disable the controls.
     */
    disableControls: function(isDisabled) {
        "use strict";
        $("#comments").attr("disabled", isDisabled);
        $("#sendMessageButton").attr("disabled", isDisabled);
    },

    /**
     * Append a paragraph or other element to the chat transcript.
     * Includes an autoscroll mechanism
     * @param {HTMLElement} para
     */
    appendParagraph: function(para) {
        "use strict";
        console.log("appendParagraph:")
        $("#history").append(para);
        $("#history").scrollTop($("#history").prop("scrollHeight"));
    },

    /**
     * Clears the chatbox.
     */
    clearMessageInput: function() {
        "use strict";
        $("#comments").val("");
    },

    /**
     * Get the value of the topic field.
     * @return {String}
    */
    getTopic: function() {
        "use strict";
        var topic = chatLogon.topic;//TODO: replaceWithHTMLEntities(jQuery("#topic option:selected").val());
        return topic;
    },

    clearUsers: function() {
        "use strict";
        $("#participants > div").children("img").attr("src", "");
        $("#participants > div").children("img").attr("class", "hidden");
        var images = $("#participants > .hidden").children("img").toArray();
        for (var i = 0; i < images.length; i++) {
            images[i].nextSibling.textContent = "";
        }
    },

    updateUserImage: function(index, imageSrc, className, displayName) {
        "use strict";
        var image = $("#participants > div > img")[index];
        image.src = imageSrc;
        image.className = className;
        image.nextSibling.textContent = displayName;
    },

    /**
     * Flip the page direction to support RTL languages.
     */
    /*
      TODO:
    */
    flipPageDirection: function() {
        "use strict";
        var dir = document.dir;
        if (dir.toUpperCase() === 'RTL') {
            document.dir = "ltr";
        } else {
            document.dir = "rtl";
        }
        this.updatePageDirection();
    },

    /**
     * Update certain text alignments to match the page direction.
     */
    /*
     TODO:
     */
    updatePageDirection: function() {
        "use strict";
        var dir = document.dir;
        if (dir.toUpperCase() === 'LTR') {
            console.log("Left-to-right. So, agent messages should be on the right-hand-side and customer on the left");
            // set the text-align fields accordingly (agent on right, customer on left)
            // you may also wish to set the chatbot as well, if you use a different style for that
            $(".agentDate").css({"text-align": "left"});
            $(".response").css({"text-align": "left"});
            $(".sent").css({"text-align": "right"});
            $(".date").css({"text-align": "right"});
        } else {
            console.log("right-to-left. So, agent messages should be on the right-hand-side and customer on the left");
            // flip the relevant fields from right to left, otherwise the agentDate will be off the screen.
            $(".agentDate").css({"text-align": "right"});
            $(".response").css({"text-align": "right"});
            $(".sent").css({"text-align": "left"});
            $(".date").css({"text-align": "left"});
        }
    },

    adjustHeight: function(){
        try{
            //alert("playwithHeight:"+playwithHeight);
            if(this.playwithHeight==true){
                var liCount=$("#history li").length;
                //&&jQuery("#comments").is(':focus')
                if(liCount<=2){
                    jQuery("#paddingDiv").css("padding-bottom","270px");
                    jQuery("#chatMessages").css("position","relative");
                    jQuery("#chatcontentcontainer").removeClass("chat-panel-margin");
                }
                else {
                    this.restoreHeight();
                    this.playwithHeight=false;
                }

            }
            else {
                // alert("Is Mobile False;:::");
            }


        }
        catch(e){
            console.log("Error in detecting mobile version");
        }
    },

    restoreHeight: function (){
        try{
            if(this.playwithHeight==true) {
                jQuery("#paddingDiv").css("padding-bottom","0px");
                jQuery("#chatMessages").css("position","fixed !important");
                if(!jQuery( "#chatcontentcontainer" ).hasClass( "chat-panel-margin" )){
                    jQuery("#chatcontentcontainer").addClass("chat-panel-margin");
                }
            }
        }
        catch(e){
            console.log("Error in detecting mobile version");
        }
    },


    scrollUp:function() {
        $( document ).ready(function() {
            $('#mobchatid').animate({scrollTop: $('#mobchatid')[0].scrollHeight}, 800);
        });

    },

    focusTextField: function() {
        jQuery("#comments").focus();
        $("#comments").height('27px');

    },

    scrollChatTrail: function() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var mobile = urlParams.get('mobile');

        if (mobile) {
            jQuery("#mobchatid").scrollTop(jQuery("#mobchatid")[0].scrollHeight);
        }
        else {
            jQuery("#chatcontentcontainer").scrollTop(jQuery("#chatcontentcontainer")[0].scrollHeight);
        }
    },
    notifyNewParticipantUI: function() {
        jQuery("#agentWaiting").hide();
        jQuery("#agentDisconnected").hide();
        jQuery("#agentConnected").show();
        document.getElementById("sendMessageButton").style.backgroundColor = Vue.prototype.$color;
        document.getElementById("sendMessageButton").style.borderColor = Vue.prototype.$color;
    },
    sendFeedback: function() {
        $("#agentWaiting").hide();
        $("#agentDisconnected").show();
        $("#agentConnected").hide();
    }

};
